import React from 'react';
import { ScissorsIcon } from 'lucide-react';
export const Header = () => {
  return <header className="bg-[#3B2A2A] shadow-md py-4 border-b border-[#D6B88E]/20" data-id="element-142">
      <div className="container mx-auto px-4 max-w-4xl flex items-center justify-between" data-id="element-143">
        <div className="flex items-center gap-2" data-id="element-144">
          <ScissorsIcon className="h-6 w-6 text-[#D6B88E]" data-id="element-145" />
          <h1 className="text-2xl font-serif font-semibold text-[#D6B88E]" data-id="element-146">
            Aneeq Salon
          </h1>
        </div>
        <nav data-id="element-147">
          <ul className="flex gap-6" data-id="element-148">
            <li className="text-[#E7D7BC] hover:text-[#D6B88E] transition-colors" data-id="element-149">
              <a href="#" className="text-sm font-medium" data-id="element-150">
                Services
              </a>
            </li>
            <li className="text-[#E7D7BC] hover:text-[#D6B88E] transition-colors" data-id="element-151">
              <a href="#" className="text-sm font-medium" data-id="element-152">
                Our Team
              </a>
            </li>
            <li className="text-[#E7D7BC] hover:text-[#D6B88E] transition-colors" data-id="element-153">
              <a href="#" className="text-sm font-medium" data-id="element-154">
                Contact
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>;
};